import { selector } from 'recoil';

import { currentAccountState } from './atoms';

export const storageCurrentAccountSelector = selector({
  key: 'currentAccountSelector',
  get: ({ get }) => get(currentAccountState),
  set: ({ set }, newValue) => {
    localStorage.setItem('current-account', JSON.stringify(newValue));
    set(currentAccountState, newValue);
  },
});
